// extracted by mini-css-extract-plugin
module.exports = {"Card":"Card_Card__53RU5","MidBox":"Card_MidBox__3Qwbd","LastBox":"Card_LastBox__3tBzy"};